import { render, staticRenderFns } from "./ExternalLinkBox.vue?vue&type=template&id=1af68b30&scoped=true&"
import script from "./ExternalLinkBox.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkBox.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLinkBox.vue?vue&type=style&index=0&id=1af68b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af68b30",
  null
  
)

export default component.exports